/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable sonarjs/prefer-immediate-return */
/* eslint-disable sonarjs/no-duplicate-string */
import { makeStyles, RACCOLOR } from '@rentacenter/racstrap';
const FONT_CHOICE = 'OpenSans-semibold';

export const localSourcingStatusModalStyles = () => {
  const useClasses = makeStyles((theme) => ({
    dialogActions: {},
    dialogTitle: {
      height: '1px',
      maxHeight: '1px',
      // backgroundColor: '#FF7777',
    },
    dialogRoot: {
      backgroundColor: '#777777',
      paddingTop: '-100px',
      height: 'auto',
      minHeight: '650px',
      '& .MuiPaper-rounded': {
        borderRadius: theme.typography.pxToRem(12),
      },
      '& .MuiDialog-paperWidthXs': {
        maxWidth: theme.typography.pxToRem(777),
      },
      '& .MuiTypography-h5': {
        fontSize: theme.typography.pxToRem(20),
        fontWeight: 500,
        lineHeight: theme.typography.pxToRem(30),
      },
    },
    dialogContent: {
      margin: `2rem 0`,
      marginTop: '-20px',
      // backgroundColor: '#7777FF',
      height: 'auto',
    },
    shopLocalsRoot: {
      width: '100%',
      minWidth: '650px',
      display: 'flex',
      flexDirection: 'column',
      // backgroundColor: '#FF7777',
      height: 'auto',
      minHeight: '650px',
      margin: 0,
      padding: 0,
    },
    taxexemptstyle: {
      display: 'flex',
      justifyContent: 'flex-start',
      gap: theme.typography.pxToRem(20),
      marginTop: '20px',
    },
    grid: {
      display: 'flex',
      justifyContent: 'flex-start',
      gap: theme.typography.pxToRem(20),
    },
    card: {
      marginTop: '40px',
      display: 'flex',
      flexDirection: 'column',
      alignContent: 'flex-end',
      bottom: 0,
      backgroundColor: '#E8F1FE',
    },
    cardBody: {
      flex: '1 1 auto',
    },
    colorit: {
      backgroundColor: '#777777',
    },
    shopLocalHeader: {
      paddingBottom: '20px',
      fontSize: '1.125rem',
    },
    infoIcon: {
      width: '18px',
      height: '18px',
      flexShrink: 0,
      color: '#2468FF',
      fill: '#2468FF',
    },
    statusstyle: {
      fontFamily: FONT_CHOICE,
      textAlign: 'left',
      fontSize: theme.typography.pxToRem(14),
      margin: 0,
      paddingLeft: '20px',
    },
    label: {
      fontFamily: FONT_CHOICE,
      textAlign: 'center',
      fontSize: theme.typography.pxToRem(14),
      color: RACCOLOR.BLUE_CRAYOLA,
      margin: 0,
      padding: 0,
    },
    answergrid: {
      marginTop: 5,
      marginBottom: 5,
      padding: 0,
    },
    progress: {
      height: '100px',
    },
    errorstyle: {
      fontFamily: FONT_CHOICE,
      textAlign: 'center',
      fontSize: theme.typography.pxToRem(14),
      color: RACCOLOR.MAXIMUM_RED,
      margin: 0,
      padding: 0,
    },
    containerStyle: {
      margin: 0,
      padding: 0,
      // backgroundColor: '#7777FF',
    },
    successstyle: {
      height: '40px',
      margin: 0,
      marginTop: '-120 px',
      paddingBottom: '10px',
      textAlign: 'center',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    spinnerstyle: {
      height: '120px',
      margin: 0,
      marginTop: '-120 px',
      paddingBottom: '0px',
      fontFamily: FONT_CHOICE,
      fontSize: theme.typography.pxToRem(16),
      textAlign: 'center',
      lineHeight: 1.435,
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    buttonContainerStyle: {
      minHeight: '70px',
      // backgroundColor: '#7777FF',
    },
    InfoHeader: {
      fontSize: theme.typography.pxToRem(16),
      fontFamily: FONT_CHOICE,
      textAlign: 'center',
      width: '100%',
      display: 'flex',
    },
    StatusHeader: {
      fontSize: '20px ',
      fontFamily: FONT_CHOICE,
      textAlign: 'center',
      fontWeight: 1400,
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      paddingBottom: '20px',
    },
    divideStyle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  }));

  const classes = useClasses();

  return classes;
};
